<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <base-setting-widget ref="base" :iteminfo="iteminfo" v-bind="$attrs" v-on="$listeners"
                       style="position: relative">
    <div class="fs-14 color-33 bold">
      颜色设置
    </div>
    <div class="text-left flex a-center m-t-10">
      <div class="block">
        <div><span class="fs-14 color-666" style="margin-right: 14px">选前颜色： </span></div>
        <div class="flex a-center">
          <div class="border p-l-5" style="width: 80px;height: 30px;line-height: 30px">
            {{ iteminfo.config.unfontcolor }}
          </div>
          <div class="block">
            <ColorPicker class="m-l-10 ld-color-pick" recommend
                         v-model="iteminfo.config.unfontcolor"/>
          </div>
        </div>
      </div>
      <div class="block m-l-10">
        <div><span class="fs-14 color-666 " style="margin-right: 14px">选后颜色： </span></div>
        <div class=" flex a-center">
          <div class="border p-l-5" style="width: 80px;height: 30px;line-height: 30px">
            {{ iteminfo.config.fontcolor }}
          </div>
          <ColorPicker class="m-l-10 ld-color-pick" recommend
                       v-model="iteminfo.config.fontcolor"/>
        </div>
      </div>
    </div>
    <div class="fs-14 color-33 bold m-v-10">
      菜单设置
    </div>
    <div class="p-v-15" style="min-height: 102px;">
      <ul class="p-b-30">
        <li :key="index" class="m-b-10" v-for="(item,index) in iteminfo.config.datalist">
          <div class="flex a-center j-center p-l-10 p-v-10"
               style="background-color: #F2F2F2;min-height: 100px">
            <div class="flex-1">
              <div class="flex" style="height: 33px;">
                <Input :maxlength="4" placeholder="菜单名称" show-word-limit=""
                       v-model="item.name"></Input>
              </div>
              <div>
                <tooltip style="width: 100%"
                         :disabled="!item.jumpObj.linkUrl"
                         max-width="250">
                  <Input class="w-full m-t-10" placeholder="加载链接地址"
                         clearable readonly
                         v-model="item.jumpObj.linkUrl">
                    <span slot="append" class="icon-link" style="cursor: pointer"
                          @click="showMaterialModal(item)"></span>
                  </Input>
                  <div slot="content" style="white-space: normal;">
                    {{ item.jumpObj.linkUrl }}
                  </div>
                </tooltip>
              </div>
            </div>
            <div class="flex-column a-center flex-s-0"
                 style="width: 50px;justify-content: space-between;min-height: 70px">
              <i :style="{color:getUpColor(index)}" @click.stop="onUpClick(index)"
                 class="icon-up fs-18"
                 style="cursor: pointer;"/>
              <i :style="{color:getDownColor(index,iteminfo.config.datalist.length)}"
                 @click.stop="onDownClick(index)"
                 class="icon-down fs-18"
                 style="cursor: pointer;"/>
              <i @click.stop="onDelClick(index)" class="icon-delete_facet fs-18"
                 style="cursor: pointer;color: #666666"/>
            </div>
          </div>
        </li>
      </ul>

    </div>

    <div class="p-b-20"
         style="position: absolute;bottom: 0;left: 20px;width:calc(100% - 40px);z-index: 999;background-color: white">
      <div @click="onItemAddClick" class="flex a-center j-center" key="abc"
           style="height: 48px;border:1px dashed #D8D8D8;cursor: pointer;background-color: #F2F2F2">
        <Icon size="24" type="ios-add"/>
        <div class="m-l-2">添加菜单</div>
      </div>
    </div>

    <!--<div class="p-15" style="min-height: 102px;background-color:#F2F2F2">-->
    <!--<ul class="flex a-center flex-wrap">-->
    <!--<li :class="{'active_style':selIndex === index}" :key="index" @click="onMenuItemClick(index)"-->
    <!--class="w-p-25 p-4 relative item_style"-->
    <!--v-for="(item,index) in iteminfo.config.datalist">-->
    <!--<div @dblclick.stop="onMenuDbItemClick(item,index)" class="flex a-center j-center sel_style"-->
    <!--style="height: 38px;border-radius: 4px;">-->
    <!--<span v-show="!item.isEdit">{{item.title}}</span>-->
    <!--<input @blur="item.isEdit=false" class="p-h-4 w-full" placeholder="菜单名称" ref="edit"-->
    <!--style="line-height: 38px"-->
    <!--v-model="item.title"-->
    <!--v-show="item.isEdit"></input>-->
    <!--</div>-->
    <!--<div class="absolute right&#45;&#45;4 top&#45;&#45;4 b-round  del_style"-->
    <!--style="width: 16px;height: 16px;background-color: #E1E1E1;">-->
    <!--<i @click.stop="iteminfo.config.datalist.splice(index,1)" class="icon-leave fs-16"-->
    <!--style="cursor: pointer;color: #999999"></i>-->
    <!--</div>-->
    <!--</li>-->
    <!--<li class="w-p-25 p-4" v-show="isAdd">-->
    <!--<div style="height: 38px;border-radius: 4px; border: 1px solid #dcdfe6;color: #333333">-->
    <!--<input @blur="onblur" class="p-h-4 w-full" placeholder="菜单名称" ref="addinput" style="line-height: 38px"-->
    <!--v-model="editText"></input>-->
    <!--</div>-->
    <!--</li>-->
    <!--<li class="w-p-25 p-4" style="color: #4B8AFF">-->
    <!--<div @click="onMenuAddClick" class="flex a-center j-center" style="height: 38px;cursor: pointer">-->
    <!--<i class="icon-add_small"></i> <span class="m-l-4">新增菜单</span>-->
    <!--</div>-->
    <!--</li>-->
    <!--</ul>-->
    <!--</div>-->
    <!--<div class="m-t-10 fs-12 color-99">-->
    <!--菜单数量最多显示4项，菜单名称最多4个字-->
    <!--</div>-->

    <!--<div class="m-t-10 b-t" v-if="getContent">-->
    <!--<div class="fs-14 color-33 bold m-v-10">-->
    <!--{{getContent.title}}内容-->
    <!--</div>-->
    <!--<div class="flex a-center" style="min-height: 73px;background-color: #F2F2F2" v-if="getContent.type === 1">-->
    <!--<div class="flex a-center p-l-10 w-full">-->
    <!--<Input class="flex-1 w-full" placeholder="链接地址" v-model="getContent.linkUrl">-->
    <!--<i class="icon-link" slot="suffix"/>-->
    <!--</Input>-->
    <!--<div class="p-h-10">-->
    <!--<i class="icon-delete_facet"></i>-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--<div class="flex-column" style="margin-top: -10px" v-if="getContent.type !== 1">-->
    <!--<ul>-->
    <!--<li :key="index" v-for="(item,index) in getContent.list">-->
    <!--<div class="flex w-full m-v-10" style="min-height: 100px;background-color: #F2F2F2"-->
    <!--v-if="item.srcType === 1">-->
    <!--<div class="flex-1 p-v-10 p-l-10">-->
    <!--<div style="min-height: 100px">-->
    <!--<div class="flex a-center j-center">-->
    <!--<up-load-image @uploadSuccess="uploadcoversuccess($event,item)" accept="image/*" picurl="crop/crop/"-->
    <!--style="width: 100%;height: 169px">-->
    <!--<template v-slot:tip>-->
    <!--<div class="bg-white border o-hidden flex a-center j-center"-->
    <!--style="width: 100%;height: 169px;cursor: pointer">-->
    <!--<img :src="getItemUrl(item)" alt="" style="width: 100%;">-->
    <!--</div>-->
    <!--</template>-->
    <!--</up-load-image>-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--<div class="flex-column a-center flex-s-0" style="width: 50px;justify-content: space-around;">-->
    <!--<i :style="{color:getUpColor(index)}" @click.stop="onUpClick(index)" class="icon-up fs-18"-->
    <!--style="cursor: pointer;"/>-->
    <!--<i :style="{color:getDownColor(index,getContent.list.length)}" @click.stop="onDownClick(index)"-->
    <!--class="icon-down fs-18" style="cursor: pointer;"/>-->
    <!--<i @click.stop="onDelClick(index)" class="icon-delete_facet fs-18"-->
    <!--style="cursor: pointer;color: #666666"/>-->
    <!--</div>-->
    <!--</div>-->
    <!--<div class="flex m-v-10" style="min-height: 100px;background-color: #F2F2F2" v-if="item.srcType === 2">-->
    <!--<div class="flex-1 p-v-10 p-l-10">-->
    <!--<div style="min-height: 100px">-->
    <!--<div class="flex a-center j-center">-->
    <!--<div class="p-r-5" style="width: 50%;">-->
    <!--<up-load-video :vidupload="false" @funcallback="onVideoUpload($event,index)"-->
    <!--@uploadSuccess="uploadVideoSuccess($event,item)" accept="video/*"-->
    <!--style="height: 101px"-->
    <!--videoInfix="news/content/">-->
    <!--<template v-slot:tip>-->
    <!--<div class="bg-white border o-hidden flex a-center j-center"-->
    <!--style="width: 100%;height: 101px;cursor: pointer;position: relative;top:0;left:0">-->
    <!--<img :src="getVideoItemUrl(item)" alt="" style="width: 100%;min-height: 100%">-->
    <!--<div class="flex a-center j-center"-->
    <!--style="position: absolute;top:0;left:0;width: 100%;height: 100%"-->
    <!--v-if="item.videoUrl && !item.process">-->
    <!--<i class="icon-player fs-30 text-white"></i>-->
    <!--</div>-->
    <!--<div class="fz-14 flex-column"-->
    <!--style="width:100%;height:40px;color: green;position: absolute;bottom: 0;background-color: #00000040;justify-content: flex-end"-->
    <!--v-if="item.process">-->
    <!--<div-->
    <!--style="width: 100%;height: 40px;line-height: 30px;text-align: center;background-color: #00000050">-->
    <!--上传进度{{item.process}}-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--</template>-->
    <!--</up-load-video>-->
    <!--</div>-->
    <!--<div class="p-l-5" style="width: 50%;">-->
    <!--<up-load-image @uploadSuccess="uploadcoversuccess($event,item)" accept="image/*"-->
    <!--picurl="crop/crop/"-->
    <!--style="height: 101px">-->
    <!--<template v-slot:tip>-->
    <!--<div class="bg-white border o-hidden flex a-center j-center"-->
    <!--style="width: 100%;height: 101px;cursor: pointer">-->
    <!--<img :src="getItemUrl(item)" alt="" style="width: 100%;min-height: 100%">-->
    <!--</div>-->
    <!--</template>-->
    <!--</up-load-image>-->
    <!--</div>-->
    <!--<div class="flex-column a-center flex-s-0 h-full"-->
    <!--style="width: 50px;justify-content: space-between;height: 101px">-->
    <!--<i :style="{color:getUpColor(index)}" @click.stop="onUpClick(index)" class="icon-up fs-18"-->
    <!--style="cursor: pointer;"/>-->
    <!--<i :style="{color:getDownColor(index,getContent.list.length)}" @click.stop="onDownClick(index)"-->
    <!--class="icon-down fs-18" style="cursor: pointer;"/>-->
    <!--<i @click.stop="onDelClick(index)" class="icon-delete_facet fs-18"-->
    <!--style="cursor: pointer;color: #666666"/>-->
    <!--</div>-->
    <!--</div>-->
    <!--<div class="flex m-t-10" style="height: 34px;margin-right: 50px">-->
    <!--<Input placeholder="视频标题" v-model="item.title"></Input>-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--</li>-->
    <!--</ul>-->
    <!--</div>-->
    <!--<div class="m-v-10 flex a-center j-center" style="min-height: 119px;background-color: #F2F2F2">-->
    <!--<div @click="onLinkClick" class="w-p-30 flex-column">-->
    <!--<div class="flex a-center j-center b-round" style="width: 48px;height: 48px;background-color: #4B8AFF">-->
    <!--<i class="icon-link text-white fs-20"></i>-->
    <!--</div>-->
    <!--<div class="fs-12 color-99 m-t-10">-->
    <!--链接地址-->
    <!--</div>-->
    <!--</div>-->
    <!--<div @click="onVideoClick" class="w-p-30 flex-column">-->
    <!--<div class="flex a-center j-center b-round" style="width: 48px;height: 48px;background-color: #4B8AFF">-->
    <!--<i class="icon-video_line text-white fs-20"></i>-->
    <!--</div>-->
    <!--<div class="fs-12 color-99 m-t-10">-->
    <!--上传视频-->
    <!--</div>-->
    <!--</div>-->
    <!--<div @click="onPicClick" class="w-p-30 flex-column">-->
    <!--<div class="flex a-center j-center b-round" style="width: 48px;height: 48px;background-color: #4B8AFF">-->
    <!--<i class="icon-camera_line text-white fs-20"></i>-->
    <!--</div>-->
    <!--<div class="fs-12 color-99 m-t-10">-->
    <!--上传图片-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <material-choice-widget
      title="选择链接"
      :pages="choosePage()"
      :on-ok="materialChoiceOk"
      ref="materialChoiceWidget"/>
  </base-setting-widget>
</template>

<script>
import BaseSettingWidget from '../base/BaseSettingWidget'
import UpLoadImage from '../../common/UpLoadImage'
import UpLoadVideo from '../../common/UpLoadVideo'
import MaterialChoiceWidget from '@/components/common/chiose/MaterialChoiceWidget'
import {getPages} from '@/components/common/chiose/MaterailChoiceWidgetUtil'


export default {
  name: 'MenuSettingWidget',
  components: {UpLoadVideo, UpLoadImage, BaseSettingWidget, MaterialChoiceWidget},
  props: {
    iteminfo: Object
  },
  data () {
    return {
      selIndex: 0,
      editText: '',
      isAdd: false,
      isChoose: false,
      selitem: null,

      clickItem2ShowMaterialModal: {},
    }
  },
  computed: {
    getContent () {
      let obj = null
      if (this.iteminfo.config.datalist && this.iteminfo.config.datalist.length) {
        if (!(this.selIndex < this.iteminfo.config.datalist.length)) {
          this.selIndex = 0
        }
        obj = this.iteminfo.config.datalist[this.selIndex]
      }
      return obj
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {

    },

    /**
     * 菜单直接加载, 不能选择首页里面的连接
     */
    choosePage () {
      let pages = getPages()
      let homePageIndex = pages.findIndex(item => item.id === 9)
      pages.splice(homePageIndex, 1)
      return pages
    },
    onblur () {
      this.iteminfo.config.datalist.push({
        name: this.editText || '菜单' + (this.iteminfo.config.datalist.length + 1),
        type: 1, //1 链接地址  2 非链接地址
        linkUrl: '',
        jumpObj: {linkUrl: ''},
        isEdit: false,
        list: [{
          srcType: 1, //1 图片  2 视频,
          title: '',   //视频标题
          coverImgUrl: '',//封面或者图片，
          videoUrl: '',    //视频地址
          process: ''
        }]
      })
      this.isAdd = false
    },
    onMenuAddClick () {
      this.editText = ''
      this.isAdd = true
      this.$nextTick(() => {
        this.$refs.addinput.focus()
      })
    },
    onMenuItemClick (index) {
      this.selIndex = index
    },
    onLinkClick () {
      if (this.getContent.type !== 1) {
        this.getContent.type = 1
      }
    },
    onVideoClick () {
      if (this.getContent.type !== 2) {
        this.getContent.type = 2
      } else {
        this.getContent.list.push({
          srcType: 2, //1 图片  2 视频,
          title: '',   //视频标题
          coverImgUrl: '',//封面或者图片，
          videoUrl: '',    //视频地址
          process: ''
        })
      }
    },
    onPicClick () {
      if (this.getContent.type !== 2) {
        this.getContent.type = 2
      } else {
        this.getContent.list.push({
          srcType: 1, //1 图片  2 视频,
          title: '',   //视频标题
          coverImgUrl: '',//封面或者图片，
          videoUrl: ''    //视频地址
        })
      }
    },
    uploadcoversuccess (data, item) {
      if (data && data.length) {
        item.coverImgUrl = data[0].url
      }
    },
    getItemUrl (item) {
      let src = require('../../../assets/tempmenu/img_picture_single.png')
      if (item.coverImgUrl) {
        src = item.coverImgUrl
      }
      return src
    },
    onUpClick (index) {
      if (index > 0) {
        let item = this.iteminfo.config.datalist[index - 1]
        this.iteminfo.config.datalist.splice(index - 1, 1)
        this.iteminfo.config.datalist.splice(index, 0, item)
      }
    },
    onDownClick (index) {
      if (index < (this.iteminfo.config.datalist.length - 1)) {
        let item = this.iteminfo.config.datalist[index + 1]
        this.iteminfo.config.datalist.splice(index + 1, 1)
        this.iteminfo.config.datalist.splice(index, 0, item)
      }
    },
    onDelClick (index) {
      let datalist = this.iteminfo.config.datalist
      datalist.splice(index, 1)
      if (!datalist.length) {
        this.onItemAddClick()
      }

      // let minCount = this.getMinCount()
      // let datalist = this.iteminfo.config.datalist
      // if (datalist && datalist.length > minCount) {      //大于最小数量的时候,删除
      //   datalist.splice(index, 1)
      // }else{
      //   if (index > -1 && index < datalist.length) {
      //     datalist[index].name=''
      //     datalist[index].jumpObj.linkUrl = ''
      //   }
      // }
    },
    getVideoItemUrl (item) {
      let src = require('../../../assets/tempmenu/img_video_single.png')
      if (item.videoUrl) {
        src = item.videoUrl + '?x-oss-process=video/snapshot,t_1000,f_png,w_0,h_0'
      }
      return src
    },
    onVideoUpload (data, index) {
      if (data) {
        this.getContent.list[index].process = Number.parseInt(data * 100) + '%'
      }
    },
    uploadVideoSuccess (data, item) {
      if (data && data.length) {
        item.videoUrl = data[0].videoUrl || ''
        if (!item.title) {
          item.title = data[0].localfile.name || ''
        }
      }
      item.process = ''
    },
    onMenuDbItemClick (item, index) {
      item.isEdit = true
      this.$nextTick(() => {
        this.$refs.edit[index].focus()
      })
    },
    getUpColor (index) {
      if (index === 0) {
        return '#BBBBBB'
      } else {
        return '#666666'
      }
    },
    getDownColor (index, length) {
      if (length === 0 || index === length - 1) {
        return '#BBBBBB'
      } else {
        return '#666666'
      }
    },
    onItemAddClick () {
      this.iteminfo.config.datalist.push({
        name: this.editText || '菜单' + (this.iteminfo.config.datalist.length + 1),
        type: 1, //1 链接地址  2 非链接地址
        linkUrl: '',
        isEdit: false,
        jumpObj: {
          'linkUrl': '',
          'linkName': '',
          'shareTitle': '',
          'shareCover': '',
          'showVideoTitle': 0,
          'showTime': 0,
          'displayType': 1,
          'subDisplayType': 1,
          'ratio': 2,
          'hSpacing': 0,
          'vSpacing': 0,
          'pSee': 1,
          'pPublish': 1,
          'pDevices': 1,
          'pUsers': [],
          'columnCount': 1
        },
        list: [{
          srcType: 1, //1 图片  2 视频,
          title: '',   //视频标题
          coverImgUrl: '',//封面或者图片，
          videoUrl: '',    //视频地址
          process: ''
        }]
      })

      this.$nextTick(() => {
        if (this.$refs.base && this.$refs.base.$refs.scrollDiv) {
          let scrollHeight = this.$refs.base.$refs.scrollDiv.scrollHeight
          this.$refs.base.$refs.scrollDiv.scrollTo({top: scrollHeight, behavior: 'smooth'})
        }
      })
    },
    onLinkChooseClick (item) {
      this.isChoose = true
      this.selitem = item
    },
    onModalClose (status) {
      if (!status) {
        this.selitem = null
      }
    },
    onChooseConfig () {
      if (this.selitem) {
        this.selitem.linkUrl = 'http://www.taobao.com/goodslist/weiliangyuansu/genxianshengshuirongfei.html'
      }
      this.isChoose = false
    },
    materialChoiceOk (data) {
      if (data && data.length > 0) {
        let item = this.clickItem2ShowMaterialModal
        item.jumpObj.linkUrl = data[0].url

        this.$nextTick(() => {
          this.checkInputOverflow()
        })
      }
    },

    showMaterialModal (item, index) {
      this.clickItem2ShowMaterialModal = item
      this.$refs.materialChoiceWidget.show()
    },
    /**
     * input输入框是否超出
     */
    checkInputOverflow (item) {
      let input = document.getElementById('input')
      if (input) {
        this.showTooltip = input.clientWidth < input.scrollWidth
      }
    },
    /**
     * 获取最低显示数量
     */
    getMinCount () {
      return 2
    },
  }
}
</script>

<style lang="scss" scoped>
.sel_style {
  border: 1px solid #dcdfe6;
  color: #333333
}

.active_style {
  .sel_style {
    border: 1px solid #4B8AFF;
    color: #4B8AFF
  }
}

.del_style {
  display: none;
}


.item_style:hover {
  .del_style {
    display: block;
  }
}

.del_style:hover {
  display: block;
}

</style>
